import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "menu", "selected"];

  toggle(event) {
    event.preventDefault();
    this.menuTarget.classList.toggle("dropdown__menu--open");
  }

  select(event) {
    const option = event.target.textContent;
    const value = event.target.dataset.value || option;
    const charSpan = this.selectedTarget.querySelector(".dropdown__char-span");
    if (charSpan) {
      charSpan.textContent = option;
    }
    this.menuTarget.classList.remove("dropdown__menu--open");

    const label = this.element.querySelector(".dropdown__label")?.textContent;

    if ((label === "Section" || label === "Sort") && value) {
      if (value.startsWith("/") || value.startsWith("http")) {
        window.location.href = value;
        return;
      }
    }

    if (
      label === "Category" ||
      label === "Price Range" ||
      label === "Sort by" ||
      label === "Region" ||
      label === "Access"
    ) {
      document.dispatchEvent(
        new CustomEvent("shop:filter", {
          detail: { filterType: label, value: value },
        }),
      );
    }
  }

  disconnect() {
    this.menuTarget?.classList.remove("dropdown__menu--open");
  }
}
